export default "__VITE_ASSET__DgX6k7fU__"